import { useEffect, useState } from 'react';
import Keycloak from 'keycloak-js';
import axios from 'axios';

export const useKeycloakInstance = (): Keycloak | null => {
  const [kcInst, setKcInst] = useState<Keycloak | null>(null);

  useEffect(() => {
    const fetchKeycloakClient = async () => {
      try {
        const keycloakJson = await axios.get(`${ process.env.PUBLIC_URL }/keycloak.json`);
        setKcInst(new Keycloak(keycloakJson.data));
      } catch (err) {
        console.log('Unable to fetch Keycloak config');
      }
    };
    fetchKeycloakClient();

    return () => {
      setKcInst(null);
    };
  }, []);

  return kcInst;
};